import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import axios from 'axios';

// Components
import DocumentationTemplate from '../../../components/templates/academic/titulation/DocumentationTemplate';

// Redux
import { useSelector } from 'react-redux';

const Main = (props) => {
    const { handleSetStateDocumentation } = props;

    // State
    const [wsGraduation, setwsGraduation] = useState(null);
    const [myWsGraduations, setmyWsGraduations] = useState(null);

    // REDUX
    const user = useSelector((state) => state.auth.user);

    useEffect(() => {
        if (myWsGraduations === null) {
            getWsGraduationById(user.partner_id);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [myWsGraduations]);

    useEffect(() => {
        if (wsGraduation === null) {
            getWsGraduation();
        }
    }, [wsGraduation]);

    // Api Functions
    const getWsGraduationById = async (id) => {
        const result = await getWsGraduationByIdService(id);
        if (result !== false) {
            setmyWsGraduations(result);
        }
        return;
    };

    const getWsGraduation = async () => {
        const result = await getWsGradiationService();
        if (result !== false) {
            setwsGraduation(result);
        }
    };

    return (
        <MainContainer>
            <DocumentationTemplate
                handleSetStateDocumentation={handleSetStateDocumentation}
            />
        </MainContainer>
    );
};

export default Main;

const URL = process.env.REACT_APP_SISAPI + '/v1/acropolis/graduation';

const getWsGraduationByIdService = async (id) => {
    const body = {
        partner_id: id,
    };
    try {
        const response = await axios.post(
            `${URL}/workshops_graduation_by_user`,
            body
        );
        return response.data.response_data;
    } catch (error) {
        console.error(error);
        return false;
    }
};

const getWsGradiationService = async () => {
    try {
        const response = await axios.get(`${URL}/get_ws_graduation`);
        return response.data.response_data;
    } catch (error) {
        console.error(error);
        return false;
    }
};

const MainContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 1rem 0;
    border-radius: 5px;
    margin-top: 1rem;
    width: 90%;
    justify-self: center;
    @media (max-width: 1024px) {
        width: 100%;
    }
`;
